/* Hook for searching YouTube channels via Convex action (Piped API). */

import { useState, useCallback } from "react";
import { useAction } from "convex/react";
import { api } from "../../convex/_generated/api";
import type { YouTubeChannelResult } from "@/types/youtubeSearch";

export function useYouTubeSearch() {
  const [results, setResults] = useState<YouTubeChannelResult[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchAction = useAction(api.youtubeSearch.searchChannels);

  const search = useCallback(async (query: string) => {
    const trimmed = query.trim();
    if (!trimmed) {
      setResults([]);
      return;
    }

    setIsSearching(true);
    setError(null);

    try {
      const data = await searchAction({ query: trimmed });
      setResults(data);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Search failed";
      setError(message);
      setResults([]);
    } finally {
      setIsSearching(false);
    }
  }, [searchAction]);

  return { results, isSearching, error, search };
}
